/** Function to handle floating point precision issues */
export const float = (n) => Number.parseFloat(n.toPrecision(12));
//# sourceMappingURL=float.js.map